module.exports = __webpack_public_path__ + "img/icon-play-video.5de15f58.svg";